(() => {
  const popup = document.querySelector('[data-zeltron-offer-popup]');
  if (!popup) return;

  const panel = popup.querySelector('[role="dialog"]');
  const closeButton = popup.querySelector('.zop__close');
  const storageKey = 'zeltron-offer-popup-dismissed-until';
  const claimedKey = 'zeltron-offer-popup-claimed';
  let previousFocus;

  function open() {
    previousFocus = document.activeElement;
    popup.classList.add('is-open');
    document.body.classList.add('zop-open');
    popup.setAttribute('aria-hidden', 'false');
    panel.setAttribute('tabindex', '-1');
    panel.focus({ preventScroll: true });
  }

  function close() {
    popup.classList.remove('is-open');
    document.body.classList.remove('zop-open');
    popup.setAttribute('aria-hidden', 'true');
    if (!(window.Shopify && window.Shopify.designMode)) {
      try {
        const days = Number(popup.dataset.dismissDays) || 7;
        localStorage.setItem(storageKey, String(Date.now() + days * 86400000));
      } catch (_) {}
    }
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  popup.querySelectorAll('[data-zop-close]').forEach((button) => button.addEventListener('click', close));
  popup.querySelector('.zop__cta')?.addEventListener('click', () => {
    try { localStorage.setItem(claimedKey, '1'); } catch (_) {}
    close();
  });
  document.addEventListener('keydown', (event) => {
    if (!popup.classList.contains('is-open')) return;
    if (event.key === 'Escape') close();
    if (event.key === 'Tab') {
      const focusable = [...panel.querySelectorAll('a[href],button:not([disabled])')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  if (window.Shopify && window.Shopify.designMode) {
    window.setTimeout(open, 500);
    return;
  }
  try {
    if (localStorage.getItem(claimedKey) === '1' || Number(localStorage.getItem(storageKey)) > Date.now()) return;
  } catch (_) {}
  window.setTimeout(open, Number(popup.dataset.delaySeconds || 0) * 1000);
})();
